import Config from "services/config/config";
import callWebService, { callTypes } from "services/utils/networks/network";
import { APPROVED_SALES_LISTING } from "./type";

export const getApprovedSaleListing = (queryObj = null, page = 1) => async (dispatch) => {

  let filterQuery = "";
  if (queryObj !== null) {
    filterQuery = `&site_no=${queryObj.site_no}&status=${queryObj.leadStatus}&client_name=${queryObj.client_name}&page=${page}`;
  }
  try {
    const teamName = await JSON.parse(localStorage.getItem("profileDetails"))[0]
      .team_id;
    const departmentName = await JSON.parse(
      localStorage.getItem("profileDetails")
    )[0].department_id;
    let apiUrl;
    if (departmentName && (departmentName === 2 || departmentName === 3)) {
      if (teamName && teamName === 7) {
        apiUrl = queryObj
        ? `${Config.preSalesList.paymentBusiness}?lead_type=1${filterQuery}`
        : `${Config.preSalesList.paymentBusiness}?lead_type=1&page=${page}`;
      } else if (teamName && teamName === 9) {
        apiUrl = queryObj
        ? `${Config.preSalesList.paymentBusiness}?lead_type=4${filterQuery}`
        : `${Config.preSalesList.paymentBusiness}?lead_type=4&page=${page}`;
      } else if (teamName && teamName === 8) {
        apiUrl = queryObj
        ? `${Config.preSalesList.paymentBusiness}?lead_type=2${filterQuery}`
        : `${Config.preSalesList.paymentBusiness}?lead_type=2&page=${page}`;
      } else {
        apiUrl = queryObj
        ? `${Config.preSalesList.paymentBusiness}?lead_type=3${filterQuery}`
        : `${Config.preSalesList.paymentBusiness}?lead_type=3&page=${page}`;
      }
    } else if (teamName && teamName === 16) {
      apiUrl = queryObj
      ? `${Config.preSalesList.paymentBusiness}?lead_type=4${filterQuery}`
      : `${Config.preSalesList.paymentBusiness}?lead_type=4&page=${page}`;
    }
// alert(apiUrl);
    dispatch({
      type: APPROVED_SALES_LISTING,
      payload: {},
    });

    const res = await callWebService(
      callTypes.get,
      "",
      `${apiUrl}`
    );

    if (res) {
      // console.log(res); return false;
      const { data } = res;
      dispatch({
        type: APPROVED_SALES_LISTING,
        payload: data.response.data,
      });
      return true;
    }
  }
  catch {
    dispatch({
      type: APPROVED_SALES_LISTING,
      payload: {},
    });
  }
};

export const getPerformaInvoice = (queryObj = null, page = 1) => async (dispatch) => {

  let filterQuery = "";
  if (queryObj !== null) {
    filterQuery = `&site_no=${queryObj.site_no}&invoice_no=${queryObj.invoice_no}&status=${queryObj.status_id}&invoice_age=${queryObj.invoice_age}&client_name=${queryObj.client_name}&page=${page}`;
  }

  try {
    const teamName = await JSON.parse(localStorage.getItem("profileDetails"))[0]
      .team_id;
    const departmentName = await JSON.parse(
      localStorage.getItem("profileDetails")
    )[0].department_id;
    let apiUrl;
    if (departmentName && (departmentName === 2 || departmentName === 3) ) {
      if (teamName && teamName === 7) {
        apiUrl = queryObj
        ? `${Config.preSalesList.performaInvoiceListing}?lead_type=1${filterQuery}`
        : `${Config.preSalesList.performaInvoiceListing}?lead_type=1&page=${page}`;
      } else if (teamName && teamName === 9) {
        apiUrl = queryObj
        ? `${Config.preSalesList.performaInvoiceListing}?lead_type=4${filterQuery}`
        : `${Config.preSalesList.performaInvoiceListing}?lead_type=4&page=${page}`;
      } else if (teamName && teamName === 8) {
        apiUrl = queryObj
        ? `${Config.preSalesList.performaInvoiceListing}?lead_type=2${filterQuery}`
        : `${Config.preSalesList.performaInvoiceListing}?lead_type=2&page=${page}`;
      } else {
        apiUrl = queryObj
        ? `${Config.preSalesList.performaInvoiceListing}?lead_type=3${filterQuery}`
        : `${Config.preSalesList.performaInvoiceListing}?lead_type=3&page=${page}`;
      }
    } else if (teamName && teamName === 16) {
      apiUrl = queryObj
      ? `${Config.preSalesList.performaInvoiceListing}?lead_type=4${filterQuery}`
      : `${Config.preSalesList.performaInvoiceListing}?lead_type=4&page=${page}`;
    }
// alert(apiUrl);
    dispatch({
      type: APPROVED_SALES_LISTING,
      payload: {},
    });

    const res = await callWebService(
      callTypes.get,
      "",
      `${apiUrl}`
    );

    if (res) {
      // console.log(res); return false;
      const { data } = res;
      dispatch({
        type: APPROVED_SALES_LISTING,
        payload: data.response.data,
      });
      return true;
    }
  }
  catch {
    dispatch({
      type: APPROVED_SALES_LISTING,
      payload: {},
    });
  }
};

export const getTaxInvoice = (queryObj = null, page = 1) => async (dispatch) => {

  let filterQuery = "";
  if (queryObj !== null) {
    filterQuery = `&site_no=${queryObj.site_no}&invoice_no=${queryObj.invoice_no}&status=${queryObj.status_id}&invoice_age=${queryObj.invoice_age}&client_name=${queryObj.client_name}&page=${page}`;
  }
  
  try {
    const teamName = await JSON.parse(localStorage.getItem("profileDetails"))[0]
      .team_id;
    const departmentName = await JSON.parse(
      localStorage.getItem("profileDetails")
    )[0].department_id;
    let apiUrl;
    if (departmentName && (departmentName === 2 || departmentName === 3)) {
      if (teamName && teamName === 7) {
        apiUrl = queryObj
        ? `${Config.preSalesList.taxInvoiceListing}?lead_type=1${filterQuery}`
        : `${Config.preSalesList.taxInvoiceListing}?lead_type=1&page=${page}`;
      } else if (teamName && teamName === 9) {
        apiUrl = queryObj
        ? `${Config.preSalesList.taxInvoiceListing}?lead_type=4${filterQuery}`
        : `${Config.preSalesList.taxInvoiceListing}?lead_type=4&page=${page}`;
      } else if (teamName && teamName === 8) {
        apiUrl = queryObj
        ? `${Config.preSalesList.taxInvoiceListing}?lead_type=2${filterQuery}`
        : `${Config.preSalesList.taxInvoiceListing}?lead_type=2&page=${page}`;
      } else {
        apiUrl = queryObj
        ? `${Config.preSalesList.taxInvoiceListing}?lead_type=3${filterQuery}`
        : `${Config.preSalesList.taxInvoiceListing}?lead_type=3&page=${page}`;
      }
    } else if (teamName && teamName === 16) {
      apiUrl = queryObj
      ? `${Config.preSalesList.taxInvoiceListing}?lead_type=4${filterQuery}`
      : `${Config.preSalesList.taxInvoiceListing}?lead_type=4&page=${page}`;
    }
// alert(apiUrl);
    dispatch({
      type: APPROVED_SALES_LISTING,
      payload: {},
    });

    const res = await callWebService(
      callTypes.get,
      "",
      `${apiUrl}`
    );

    if (res) {
      // console.log(res); return false;
      const { data } = res;
      dispatch({
        type: APPROVED_SALES_LISTING,
        payload: data.response.data,
      });
      return true;
    }
  }
  catch {
    dispatch({
      type: APPROVED_SALES_LISTING,
      payload: {},
    });
  }
};

//get list of tax invoice lob
export const getTaxInvoiceLob = (queryObj = null, page = 1) => async (dispatch) => {

  let filterQuery = "";
  if (queryObj !== null) {
    filterQuery = `&site_no=${queryObj.site_no}&invoice_no=${queryObj.invoice_no}&status=${queryObj.status_id}&invoice_age=${queryObj.invoice_age}&client_name=${queryObj.client_name}&page=${page}`;
  }
  
  try {
    const teamName = await JSON.parse(localStorage.getItem("profileDetails"))[0]
      .team_id;
    const departmentName = await JSON.parse(
      localStorage.getItem("profileDetails")
    )[0].department_id;
    let apiUrl;
    if (departmentName && (departmentName === 2 || departmentName === 3)) {
      if (teamName && teamName === 7) {
        apiUrl = queryObj
        ? `${Config.preSalesList.taxInvoiceListingLob}?lead_type=1${filterQuery}`
        : `${Config.preSalesList.taxInvoiceListingLob}?lead_type=1&page=${page}`;
      } else if (teamName && teamName === 9) {
        apiUrl = queryObj
        ? `${Config.preSalesList.taxInvoiceListingLob}?lead_type=4${filterQuery}`
        : `${Config.preSalesList.taxInvoiceListingLob}?lead_type=4&page=${page}`;
      } else if (teamName && teamName === 8) {
        apiUrl = queryObj
        ? `${Config.preSalesList.taxInvoiceListingLob}?lead_type=2${filterQuery}`
        : `${Config.preSalesList.taxInvoiceListingLob}?lead_type=2&page=${page}`;
      } else {
        apiUrl = queryObj
        ? `${Config.preSalesList.taxInvoiceListingLob}?lead_type=3${filterQuery}`
        : `${Config.preSalesList.taxInvoiceListingLob}?lead_type=3&page=${page}`;
      }
    } else if (teamName && teamName === 16) {
      apiUrl = queryObj
      ? `${Config.preSalesList.taxInvoiceListingLob}?lead_type=4${filterQuery}`
      : `${Config.preSalesList.taxInvoiceListingLob}?lead_type=4&page=${page}`;
    }
    //alert(apiUrl);
    dispatch({
      type: APPROVED_SALES_LISTING,
      payload: {},
    });

    const res = await callWebService(
      callTypes.get,
      "",
      `${apiUrl}`
    );

    if (res) {
      // console.log(res); return false;
      const { data } = res;
      dispatch({
        type: APPROVED_SALES_LISTING,
        payload: data.response.data,
      });
      return true;
    }
  }
  catch {
    dispatch({
      type: APPROVED_SALES_LISTING,
      payload: {},
    });
  }
};

//bulk assign tax invoices
export const bulkAssigneTaxInvoices = (requestData) => async () => {
  const res = await callWebService(
    callTypes.post,
    requestData,
    Config.preSalesList.bulkChangeAssigneeForTaxInvoices
  );
  if (res?.data?.response?.status === true) {
    return true;
  }
};

export const getPaymentRequest = (queryObj = null, page = 1) => async (dispatch) => {

  let filterQuery = "";
  if (queryObj !== null) {
    filterQuery = `&invoice_no=${queryObj.invoice_no}&client_name=${queryObj.client_name}&action_status=${queryObj.action_status}&request_type=${queryObj.request_type}&fromDate=${queryObj.fromDate}&toDate=${queryObj.toDate}&page=${page}`;
  }
  try {
    const teamName = await JSON.parse(localStorage.getItem("profileDetails"))[0]
      .team_id;
    const departmentName = await JSON.parse(
      localStorage.getItem("profileDetails")
    )[0].department_id;
    let apiUrl;
    if (departmentName && (departmentName === 2 || departmentName === 3)) {
      if (teamName && teamName === 7) {
        apiUrl = queryObj
        ? `${Config.preSalesList.paymentRequest}?lead_type=1${filterQuery}`
        : `${Config.preSalesList.paymentRequest}?lead_type=1&page=${page}`;
      } else if (teamName && teamName === 9) {
        apiUrl = queryObj
        ? `${Config.preSalesList.paymentRequest}?lead_type=4${filterQuery}`
        : `${Config.preSalesList.paymentRequest}?lead_type=4&page=${page}`;
      } else if (teamName && teamName === 8) {
        apiUrl = queryObj
        ? `${Config.preSalesList.paymentRequest}?lead_type=2${filterQuery}`
        : `${Config.preSalesList.paymentRequest}?lead_type=2&page=${page}`;
      } else {
        apiUrl = queryObj
        ? `${Config.preSalesList.paymentRequest}?lead_type=3${filterQuery}`
        : `${Config.preSalesList.paymentRequest}?lead_type=3&page=${page}`;
      }
    } else if (teamName && teamName === 16) {
      apiUrl = queryObj
      ? `${Config.preSalesList.paymentRequest}?lead_type=4${filterQuery}`
      : `${Config.preSalesList.paymentRequest}?lead_type=4&page=${page}`;
    }
// alert(apiUrl);
    dispatch({
      type: APPROVED_SALES_LISTING,
      payload: {},
    });
    // ${queryObj === null && `&page=${page}`}
    const res = await callWebService(
      callTypes.get,
      "",
      `${apiUrl}`
    );

    if (res) {
      // console.log(res); return false;
      const { data } = res;
      dispatch({
        type: APPROVED_SALES_LISTING,
        payload: data.response.data,
      });
      return true;
    }
  }
  catch {
    dispatch({
      type: APPROVED_SALES_LISTING,
      payload: {},
    });
  }
};
